// Tipos de archivo que la app muestra dentro de la pantalla (decision 0092).
export const IMAGENES = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
export const TABLAS = ['xls', 'xlsx', 'xlsm', 'csv', 'ods'];
export const extensionDe = (nombre: string) => nombre.split('.').pop()?.toLowerCase() ?? '';

// Si un archivo del expediente se ve dentro de la app (PDF o imagen).
export const seVeEnLaApp = (nombre: string) => extensionDe(nombre) === 'pdf' || IMAGENES.includes(extensionDe(nombre));
